import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IConfirmDialogData } from '../../../services/confirm-dialog.service';

@Component({
  selector: 'dialog-confirm-component',
  templateUrl: 'dialog-confirm.component.html',
})
export class DialogConfirmtComponent {

  isAlert: boolean;
  title: string;
  content: string;
  okButtonText: string;
  noOkButtonText: string;
  blockOkButton: boolean;
  isBlockOkButton: boolean;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmtComponent>
    , @Inject(MAT_DIALOG_DATA) public data: IConfirmDialogData) {
    this.title = data.Title;
    this.content = data.Content;
    this.okButtonText = data.OkButtonText;
    this.noOkButtonText = data.NoOkButtonText;
    this.isAlert = data.IsAlert;
    this.blockOkButton = data.BlockOkButton;
  }

  onOkClick(): void {
    this.isBlockOkButton = true;
    this.dialogRef.close(true);
  }

  onNoOkClick(): void {
    this.dialogRef.close(false);
  }
}
